<script setup lang="ts">
import { computed, ref } from 'vue';

import { translate } from '@/shared/i18n';
import { ProjectSettings, pwaService, PwaInstructionsPlatform } from '@/shared/lib';
import { Btn, Icon, Popup } from '@/shared/ui';

const { label, showTitle = false } = defineProps<{
  label?: string;
  showTitle?: boolean;
}>();

const isInstructionsOpened = ref<boolean>(false);
const pwaInstallInstructions: Record<PwaInstructionsPlatform, string> = {
  [PwaInstructionsPlatform.IOS]:
    'Нажмите «Поделиться» в Safari, затем выберите «На экран “Домой”».',
  [PwaInstructionsPlatform.ANDROID]:
    'Откройте меню браузера и выберите «Установить приложение» или «Добавить на главный экран».',
  [PwaInstructionsPlatform.OTHER]:
    'Откройте меню браузера и найдите пункт установки приложения или добавления на главный экран.',
};
const instructions = computed<string>(() => {
  return pwaInstallInstructions[pwaService.instructionsPlatform.value];
});

const onClickInstall = async () => {
  const hasOpenedNativePrompt = await pwaService.requestInstallation();
  if (!hasOpenedNativePrompt) {
    isInstructionsOpened.value = true;
  }
};
</script>

<template>
  <div class="flex w-full flex-col gap-3">
    <p
      v-if="showTitle"
      class="text-sm text-[var(--theme-text-secondary)]"
    >
      {{ translate('pwa.installTitle', { name: ProjectSettings.project.name }) }}
    </p>

    <Btn
      type="primary"
      @click="onClickInstall"
    >
      <Icon
        name="lucide:download"
        width="20"
        height="20"
        class="mr-1"
      />

      {{ label ?? translate('pwa.install') }}
    </Btn>

    <Popup
      v-model:show="isInstructionsOpened"
      overlay
      close-on-click-overlay
      position="bottom"
      teleport="body"
    >
      <div class="w-[min(100vw,800px)] p-6 pb-[max(1.5rem,env(safe-area-inset-bottom))]">
        <h4 class="text-primary text-lg">
          {{ translate('pwa.bannerTitle', { name: ProjectSettings.project.name }) }}
        </h4>

        <p class="mt-3 text-sm leading-6 text-[var(--theme-text-secondary)]">
          {{ instructions }}
        </p>
      </div>
    </Popup>
  </div>
</template>
